import initialState from "./router.store";
import { setRouteChanged } from "./router.actions";
import { createReducer } from "@reduxjs/toolkit";
export default createReducer(initialState, (builder) => {
    builder.addCase(setRouteChanged, (state, { payload }) => {
        state.location = payload;
    });
});
